/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, AnyAction } from '@reduxjs/toolkit';

import type { Failure } from 'state/shared/types';

export enum NotificationSeverity {
  error,
  info,
  success,
  warning,
}

export type Notification = {
  id: string;
  message: string;
  notificationSeverity: NotificationSeverity;
  isClosableByUser?: boolean;
};

type ErrorAction = PayloadAction<Failure>;

const isDisplayableErrorAction = (action: AnyAction): action is ErrorAction =>
  typeof action.type === 'string' &&
  action.type.endsWith('_FAILURE') &&
  !(action as ErrorAction).payload.hideNotification;

const notificationFromErrorAction = (action: ErrorAction): Notification => ({
  id: action.payload.id,
  message: action.payload.error,
  notificationSeverity: NotificationSeverity.error,
  isClosableByUser: true,
});

const initialState: {
  open: Notification[];
} = {
  open: [],
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    ADD_NOTIFICATION(state, action: PayloadAction<Notification>) {
      state.open.push(action.payload);
    },
    REMOVE_NOTIFICATION(state, action: PayloadAction<string>) {
      state.open = state.open.filter(
        (notification) => notification.id !== action.payload
      );
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isDisplayableErrorAction, (state, action) => {
      const notification = notificationFromErrorAction(action);
      state.open.push(notification);
    });
  },
});

export const notificationsActions = notificationsSlice.actions;

export default notificationsSlice.reducer;
